import React from 'react';

// MUI
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import logoIconDark from '../../assets/images/logo.svg';

const AddRemovalSuccess = ({ error, resetForm }) => {
    const heading = error ? 'Hmmm, that’s awkward…' : 'Success!';
    const message = error
        ? error.inviteError ||
          error.userError ||
          'There was an issue submitting your request. Please double-check your information and try again. If this persists, contact your Community Manager for assistance.'
        : 'We received your information. Your request has been sent to your Community Manager.';

    const button = error ? 'Try Again' : 'New Removal Request';

    return (
        <Container maxWidth="sm">
            <Card elevation={6} sx={{ borderRadius: 3 }}>
                <CardContent>
                    <Stack
                        spacing={3}
                        alignItems="center"
                        textAlign="center"
                        sx={{ mt: 2 }}
                    >
                        <Box
                            component="img"
                            src={logoIconDark}
                            alt="Sage logo"
                            sx={{ height: 101, width: 'auto' }}
                        />
                        <Typography variant="h4" fontWeight={600}>
                            {heading}
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            {message}
                        </Typography>
                        <Box sx={{ pt: 1 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                    error ? resetForm('soft') : resetForm('hard')
                                }
                            >
                                {button}
                            </Button>
                        </Box>
                    </Stack>
                </CardContent>
            </Card>
        </Container>
    );
};

export default AddRemovalSuccess;
